var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextField',{attrs:{"type":"text","placeholder":_vm.label,"value":_vm.value,"rules":_vm.rules.concat( [_vm.validation.url])},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }